import { AutoGraph } from '@mui/icons-material';
import { type Theme, Typography, styled } from '@mui/material';
import { purple } from '@mui/material/colors';
import { type SystemStyleObject } from '@mui/system';

const Container = styled('span')({
  display: 'flex',
  flexDirection: 'column',
});

const InnerContainer = styled('span')({
  alignItems: 'center',
  display: 'flex',
});

export type Props = {
  popularity: number;
  sx?: SystemStyleObject<Theme>;
};

export const PopularityBadge = ({ popularity, sx = {} }: Props) => (
  <Container sx={sx}>
    <Typography sx={{ color: theme => theme.supportingTextPrimary, fontSize: '0.75rem', textAlign: 'center' }}>
      POPULARITY
    </Typography>
    <InnerContainer>
      <AutoGraph
        sx={{
          color: purple[500],
          fontSize: '2.5rem',
          marginRight: theme => theme.spacing(0.5),
        }}
      />
      <Typography
        sx={{
          color: theme => theme.mainTextPrimary,
          display: 'inline-block',
        }}
        variant="h6"
      >
        <strong>{popularity.toFixed(2)}</strong>
      </Typography>
    </InnerContainer>
  </Container>
);
